import { AnimatedPage, FadeIn } from "../../../../components/AnimatedPage";
import { Card, CardContent } from "../../../../components/ui/card";
import { LiquidationUploadSection } from "./components/LiquidationUploadSection";
import { useLiquidation } from "./hooks/useLiquidation";

export default function GestorLiquidacao() {
  const {
    selectedFund,
    fileStatusData,
    loading,
    getLiquidationConfig,
    resetRefresh,
    calculateErrorPercentage,
    calculateSuccessPercentage,
    getErrorCount,
    getSuccessCount,
    aguardandoProcessamento,
  } = useLiquidation();

  const liquidationConfig = selectedFund
    ? getLiquidationConfig(selectedFund)
    : null;

  return (
    <AnimatedPage className="p-6">
      <FadeIn className="mb-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">
            Liquidação de Créditos
          </h1>
          <p className="text-muted-foreground mt-1">
            Upload de créditos liquidados
          </p>
        </div>
      </FadeIn>

      {liquidationConfig ? (
        <FadeIn delay={0.1}>
          <LiquidationUploadSection
            docType={liquidationConfig.docType}
            extensionFile=".xlsx"
            uploadTitle="Upload liquidados"
            dbName={liquidationConfig.dbName}
            fileStatusData={fileStatusData}
            aguardandoProcessamento={aguardandoProcessamento}
            onUploadComplete={resetRefresh}
            calculateErrorPercentage={calculateErrorPercentage}
            calculateSuccessPercentage={calculateSuccessPercentage}
            getErrorCount={getErrorCount}
            getSuccessCount={getSuccessCount}
          />
        </FadeIn>
      ) : (
        <FadeIn delay={0.1}>
          <Card>
            <CardContent className="py-12">
              <div className="text-center">
                <h2 className="text-xl font-semibold text-foreground">
                  Não há liquidação configurada para este cliente.
                </h2>
              </div>
            </CardContent>
          </Card>
        </FadeIn>
      )}

      {loading && (
        <div className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50">
          <Card className="w-96">
            <CardContent className="py-12">
              <div className="text-center space-y-4">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto" />
                <p className="text-muted-foreground">Processando upload...</p>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </AnimatedPage>
  );
}
